import { api } from "@/services";
import { SuggestionObject } from "@/types/Shared/Search";
import qs from "qs";

type SuggestionItem = {
  term: string;
  url?: string;
  urlb?: string;
  image?: string;
};

type SuggestionsResponse = {
  suggestion?: Partial<Record<"Product" | "Size" | "Vehicle" | "Term", SuggestionItem[]>>;
};

function vehicleLink(url: string) {
  const [Path, Query] = (url ?? "").split("?");
  const Params = qs.parse(Query ?? "") as Record<string, string>;
  if (!Params.veiculoMarca || !Params.veiculoModelo) {
    return url;
  }
  return `${Path}?${qs.stringify({
    brand: Params.veiculoMarca,
    model: Params.veiculoModelo,
    year: Params.veiculoAno
  })}`;
}

function toSuggestionList(data: SuggestionsResponse | SuggestionObject[]): SuggestionObject[] {
  if (Array.isArray(data)) {
    return data;
  }

  const { Product = [], Size = [], Vehicle = [] } = data?.suggestion ?? {};

  return [
    ...Product.map((item) => {
      const Slug = item.url?.replace(/^\/?pneu\//, "");
      return { ...item, url: Slug, productId: Slug, typeTerm: "Product" };
    }),
    ...Size.map((item) => ({ ...item, urlb: item.urlb ?? item.url, typeTerm: "Size" })),
    ...Vehicle.map((item) => ({ ...item, urlb: vehicleLink(item.url), typeTerm: "Vehicle" }))
  ] as SuggestionObject[];
}

async function useAsyncSuggestions(SearchTerm: string) {
  const PrimaryStore = process.env.NEXT_PUBLIC_PRIMARY_STORE;
  const SecondaryStore = process.env.NEXT_PUBLIC_SECONDARY_STORE;

  let Response = null;
  let SError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/SearchEngine/Sugestions", {
        signal: Controller.signal,
        params: {
          term: SearchTerm,
          stores: [PrimaryStore, SecondaryStore]
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      });
      const Suggestions = toSuggestionList(Resp?.data);
      if (Resp?.status === 200 && Suggestions.length) {
        Response = Suggestions;
      } else {
        SError = "Nenhuma sugestão encontrada";
      }
    } catch (Err) {
      SError = Err?.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, SError];
}

export { useAsyncSuggestions };
